export function createDownloadLinkFromBlob(data, fileName) {
  const blob = new Blob([data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode && link.parentNode.removeChild(link);
  return link;
}



// WEBPACK FOOTER //
// ./src/utils/createDownloadLinkFromBlob.js